import type { GenerationType } from '../../../../../shared-generation-pricing-config'

/**
 * Recovers the base model and generation type from a generation UnifiedModel
 * id (`${baseModel}/${genType.toLowerCase()}`, e.g.
 * `google/nano-banana-2/text_to_image`). Base model ids may themselves
 * contain slashes, so the generation type is always the last path segment.
 */
export function parseGenerationId(id: string): { baseModel: string; genType: GenerationType } {
  const idx = id.lastIndexOf('/')
  return {
    baseModel: id.slice(0, idx),
    genType: id.slice(idx + 1).toUpperCase() as GenerationType,
  }
}
